'use client'

import { AwazeThemeProvider } from '@awazevr/design-system.components.awaze-theme-provider'
import { GlobalStyle } from '@awazevr/design-system.components.global-style'

import { TmsProvider } from './tmsProvider'
import { formatDataLayerSlug } from './tmsProvider.utils'
import { getEnvironmentVariable } from '@/helpers/environment'
import { getLocale } from '@/helpers/locale'

export default function AwazeTheme({
  children,
}: {
  children: React.ReactNode
}) {

  const userAgent =
    typeof window !== 'undefined' ? window.navigator.userAgent : ''
  const isMobile = Boolean(
    userAgent?.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    )
  )

  const isAppWebview = userAgent.includes('awz-owner-wv')

  const getEnvironment = () => {
    const url = window.location.href
    const environments = ['localhost', 'dev', 'ppe']
    let env = 'live'

    environments.forEach(e => {
      const match = url.match(e)
      if (match) {
        env = match[0]
      }
    })

    return env
  }

  const pageSlug = typeof window !== 'undefined' ? window.location.pathname : ''

  return (
    <>
      {isAppWebview ? ( // New GA4 only triggetered in webview
        <TmsProvider
          pageLoadDataObject={{
            awaze_device_type: isMobile ? 'mobile' : 'desktop',
            site_environment: getEnvironment(),
            page_name: formatDataLayerSlug(pageSlug || ''),
            page_section: '',
            page_type: '',
            site_brand: 'awaze',
            site_currency: '',
            site_locale: getLocale(),
            site_sub_brand: '',
            site_version: getEnvironmentVariable('BUILD_ID', '1.0.0') ?? '1.0.0',
          }}
          id="GTM-N64LSFS7"
        >
          <AwazeThemeProvider brand="agnostic">
            <GlobalStyle />
            {children}
          </AwazeThemeProvider>
        </TmsProvider>
      ) : (
        <AwazeThemeProvider brand="agnostic">
          <GlobalStyle />
          {children}
        </AwazeThemeProvider>
      )}
    </>
  )
}
